import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ProductType} from "@/shared/model/productType";
import SogButton from "@/shared/ui/SogButton.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import {storeToRefs} from "pinia";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectProductTypeComponent',
  setup(__props) {


const _shoppingCartStore = useShoppingCartStore();
const _router = useRouter();

const {currentProductTypes} = storeToRefs(_shoppingCartStore);


async function onSelectProductType(value: ProductType) {
  await _shoppingCartStore.setProductType(value);
  if (value === ProductType.ExportBlank) {
    await _router.push({path: "productprice"});
  } else {
    await _router.push({path: "product"});
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogFlexColumn, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogButton, {
                style: {"height":"80px","padding":"10px"},
                class: "full-width",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelectProductType(_unref(ProductType).Kzk)))
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Kurzzeitkennzeichen ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _unref(currentProductTypes).kzk]
              ]),
              _withDirectives(_createVNode(SogButton, {
                style: {"height":"80px"},
                class: "full-width",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelectProductType(_unref(ProductType).Zoll)))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Ausfuhrkennzeichen ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _unref(currentProductTypes).zoll]
              ]),
              _withDirectives(_createVNode(SogButton, {
                style: {"height":"80px"},
                class: "full-width",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onSelectProductType(_unref(ProductType).Tz)))
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Tageszulassung ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _unref(currentProductTypes).tz]
              ]),
              _withDirectives(_createVNode(SogButton, {
                style: {"height":"80px"},
                class: "full-width",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onSelectProductType(_unref(ProductType).ExportBlank)))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Ausfuhrversicherungsformulare ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _unref(currentProductTypes).exportBlank]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})